import React, { memo } from 'react';
import { ColorItem } from '@fourthwall/components';
import { OpacityWrapper, ProductInfo } from '../ProductsListItem/ProductsListItem.styled';
import * as S from './ProductsListItemVariantContent.styled';
export const ProductsListItemVariantContent = memo(({ item, input }) => (React.createElement(React.Fragment, null,
    React.createElement(S.Indent, null),
    React.createElement(OpacityWrapper, null, input),
    React.createElement(ProductInfo, null,
        React.createElement(OpacityWrapper, null,
            React.createElement(S.EnhancedItemName, null,
                item.color && React.createElement(ColorItem, { size: "small", color: item.color }),
                item.name))))));
